import React from "react";
import "./Produk.scss";
import data from "./data.json";
import Card from "../../Component/Card Viola/cardviola";
import Eastern5images from "../../Media/Produk/Eastern/Eastern5";
import Eastern6images from "../../Media/Produk/Eastern/Eastern6";
import Eastern7images from "../../Media/Produk/Eastern/Eastern7";
import Eastern6Atticimages from "../../Media/Produk/Eastern/Eastern6attic";
import Eastern7Atticimages from "../../Media/Produk/Eastern/Eastern7attic";

const imageMap = {
  Eastern5images,
  Eastern6images,
  Eastern7images,
  Eastern6Atticimages,
  Eastern7Atticimages,
  // Add other image arrays here if you have more sets
};

const produk = () => {
  return (
    <div id="produk" className="produk">
      <h1>Our Residentials</h1>
      <h2>Cicilan Start From 5 Juta/Bulan</h2>
      <div className="cardhome-containerf">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
